import { render, staticRenderFns } from "./tblUpdateScprixFiles.html?vue&type=template&id=2365826b&scoped=true&"
import script from "./tblUpdateScprixFiles.ts?vue&type=script&lang=ts&"
export * from "./tblUpdateScprixFiles.ts?vue&type=script&lang=ts&"
import style0 from "./tblUpdateScprixFiles.scss?vue&type=style&index=0&id=2365826b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365826b",
  null
  
)

/* custom blocks */
import block0 from "./tblUpdateScprixFiles.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Ftasks%2FtblUpdateScprixFiles%2FtblUpdateScprixFiles.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VImg,VProgressCircular,VRow,VTooltip})
